import spTheme from "./spTheme";
import merge from 'lodash.merge';

/**
 * Custom type to provide a deep partial of a object.
 */

/**
 * Factory for merging partial consumer theme with the base theme
 */
var mergePartialTheme = (partialTheme, baseTheme) => {
  return merge(baseTheme || spTheme, partialTheme);
};
export default mergePartialTheme;